import React, { useEffect, useRef, useState } from "react";
import "./FadeInSection.css";

const FadeInSection = ({ children, as: Component = 'div', ...props }) => {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    setVisible(entry.isIntersecting);
                });
            },
            { threshold: 0.1 }
        );

        const current = domRef.current;
        if (current) observer.observe(current);

        return () => {
            if (current) observer.unobserve(current);
        };
    }, []);

    return (
        <Component
            ref={domRef}
            className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
            {...props}
        >
            {children}
        </Component>
    );
};

export default FadeInSection;
